/* =====================================================================================================================
   MJP CARRELLO (sections/mjp-cart.liquid)
   * Quantita' / rimozione: /cart/change.js con la Section Rendering API -> si ridisegna solo [data-mct-body].
     Poi "cart:refresh" (contatore del tema) e refreshCart() di Kaching, cosi' drawer e icona restano allineati.
   * Gift card: le carte applicate le dice l'API Storefront (window.MJPGiftCart, assets/mjp-gc-cart.js); qui si
     mostrano come righe del riepilogo e il totale diventa "Da pagare" = totale - carte. Shopify al pagamento scala
     lo stesso importo (fino al totale dell'ordine).
   * La carta si legge con il lettore nel dialog (snippets/mjp-giftcard-scanner.liquid, modalita' "cart") oppure dal
     computer con il QR: in entrambi i casi arriva l'evento "mjp:gc-applied".
   ===================================================================================================================== */
(function () {
  'use strict';
  if (window.__mjpCart) return;
  window.__mjpCart = true;

  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    cents = Math.round(+cents || 0);
    format = format || '€{{amount_with_comma_separator}}';
    function fmt(n, dec, th, ds) {
      var p = (n / 100).toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? ds + p[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, '.', ',');
      }
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* mjp-gc-cart.js si carica in fondo alla pagina: si aspetta che ci sia */
  function whenGC(fn, n) {
    if (window.MJPGiftCart) return fn(window.MJPGiftCart);
    if ((n || 0) > 60) return;
    setTimeout(function () { whenGC(fn, (n || 0) + 1); }, 100);
  }

  function init(root) {
    if (root.dataset.mctBound) return;
    root.dataset.mctBound = '1';
    var D = root.dataset, section = D.section, gcOn = D.gc === 'true';
    var cards = [], busy = false;

    function body() { return root.querySelector('[data-mct-body]'); }
    function state() { return root.querySelector('[data-mct-state]'); }

    /* ---------------- quantita' ---------------- */
    function change(key, qty) {
      if (busy) return;
      busy = true;
      root.classList.add('is-busy');
      var line = root.querySelector('[data-line="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      if (line) line.classList.add('is-busy');
      fetch(ROOT_URL + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: [section], sections_url: location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (res.ok && res.j.sections && res.j.sections[section]) {
            var doc = new DOMParser().parseFromString(res.j.sections[section], 'text/html');
            var fresh = doc.querySelector('[data-mct-body]');
            if (fresh) body().innerHTML = fresh.innerHTML;
          } else if (!res.ok) {
            /* es. quantita' oltre la giacenza: si ridisegna com'era e si mostra il messaggio di Shopify */
            if (line) { line.classList.remove('is-busy'); flash(line, res.j.description || res.j.message || ''); }
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          try { if (window.kachingCartApi && window.kachingCartApi.refreshCart) window.kachingCartApi.refreshCart(); } catch (e) {}
          renderGC();
          if (gcOn) loadGC();
        })
        .catch(function () { location.reload(); })
        .then(function () { busy = false; root.classList.remove('is-busy'); });
    }

    function flash(line, text) {
      if (!text) return;
      var p = line.querySelector('.mct-item__err');
      if (!p) { p = document.createElement('p'); p.className = 'mct-item__err'; p.setAttribute('role', 'alert'); line.querySelector('.mct-item__info').appendChild(p); }
      p.textContent = text;
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var step = t.closest('[data-qty-step]');
      if (step) {
        var li = step.closest('[data-line]'), inp = li.querySelector('.mct-qty__in');
        var cur = +inp.value || 0, d = +step.getAttribute('data-qty-step');
        var next = step.hasAttribute('data-remove-at-min') && d < 0 ? 0 : Math.max(0, cur + d);
        var max = inp.max ? +inp.max : Infinity;
        if (next > max) return;
        change(li.getAttribute('data-line'), next);
        return;
      }
      var rm = t.closest('[data-remove]');
      if (rm) { change(rm.closest('[data-line]').getAttribute('data-line'), 0); return; }
      if (t.closest('[data-mct-gc-scan]')) { openScanner(); return; }
      if (t.closest('[data-mct-gc-old]')) { openScanner('old'); return; }
      if (t.closest('[data-mct-gc-qr]')) { whenGC(function (G) { G.openQR(); }); return; }
      var gcrm = t.closest('[data-mct-gc-rm]');
      if (gcrm) { removeCard(gcrm); return; }
      if (t.closest('[data-mct-dlg-close]')) { closeScanner(); }
    });

    root.addEventListener('change', function (e) {
      var inp = e.target.closest('.mct-qty__in');
      if (inp) {
        var v = Math.max(0, parseInt(inp.value, 10) || 0);
        if (inp.max && v > +inp.max) v = +inp.max;
        change(inp.closest('[data-line]').getAttribute('data-line'), v);
        return;
      }
      var note = e.target.closest('[data-mct-note]');
      if (note) {
        fetch(ROOT_URL + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).catch(function () {});
      }
    });

    /* ---------------- gift card ---------------- */
    function totalCents() { var s = state(); return s ? +s.getAttribute('data-total') : 0; }

    function renderGC() {
      var b = body(); if (!b) return;
      var rows = b.querySelector('[data-mct-gcrows]');
      if (!rows) return;
      var fmt = D.moneyFormat, used = 0, left = 0;
      rows.innerHTML = cards.map(function (g) {
        var u = Math.round(+g.amountUsed.amount * 100);
        used += u;
        if (g.balance) left += Math.max(0, Math.round(+g.balance.amount * 100) - u);
        return '<div class="mct-row mct-row--gc">' +
          '<span class="mct-row__gc"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="5" width="19" height="14" rx="2.5"/><path d="M2.5 15h19"/></svg>' +
          esc(D.tRow) + ' •••• ' + esc(String(g.lastCharacters).toUpperCase()) +
          '<button type="button" class="mct-row__rm" data-mct-gc-rm="' + esc(g.id) + '">' + esc(D.tRemove) + '</button></span>' +
          '<span>−' + esc(formatMoney(u, fmt)) + '</span></div>';
      }).join('');
      var tot = totalCents(), due = Math.max(0, tot - used);
      /* Saldo applicato: totale originale barrato in grigio + totale finale */
      b.querySelectorAll('[data-mct-due]').forEach(function (n) {
        if (n.hasAttribute('data-plain')) { n.textContent = formatMoney(cards.length ? due : tot, fmt); return; } /* pulsante: una riga */
        n.innerHTML = cards.length
          ? '<s class="mct-was">' + esc(formatMoney(tot, fmt)) + '</s> <span class="mct-now">' + esc(formatMoney(due, fmt)) + '</span>'
          : esc(formatMoney(tot, fmt));
      });
      b.querySelectorAll('[data-mct-total-label]').forEach(function (n) { n.textContent = cards.length ? D.tDue : D.tTotal; });
      /* Con la riserva il saldo che resta = parte riservata + parte non usata dell'importo scelto */
      if (reservation) left = (+reservation.reserved_cents || 0) + Math.max(0, (+reservation.usable_cents || 0) - used);
      var l = b.querySelector('[data-mct-left]');
      if (l) {
        var lines = [];
        if (cards.length && left > 0) lines.push(String(D.tLeft || '').replace('[amount]', formatMoney(left, fmt)));
        if (cards.length && reservation && reservation.expires_at && window.MJPGiftCart) {
          var t = new Date(reservation.expires_at);
          if (!isNaN(t)) lines.push(((window.MJPGiftCart.config.t || {}).reserved_until || '') + ' ' + t.toLocaleTimeString(document.documentElement.lang || 'it-IT', { hour: '2-digit', minute: '2-digit' }));
        }
        l.hidden = !lines.length;
        l.innerHTML = lines.map(esc).join('<br>');
      }
      root.classList.toggle('has-gc', cards.length > 0);
    }

    /* Primo caricamento: rinnovo della riserva (importo parziale). Riserva scaduta -> carta tolta + avviso. */
    var reservation = null, first = true;
    function loadGC() {
      whenGC(function (G) {
        var step = first && G.config.partial
          ? G.syncReservation('renew').then(function (r) {
              reservation = r.res && r.res.status === 'active' ? r.res : null;
              if (r.dropped) notice((G.config.t || {}).expired);
              return r.cart;
            })
          : G.myCart().then(function (c) { return c.count ? G.status(c.gid) : null; });
        first = false;
        step.then(function (cart) {
          cards = (cart && cart.appliedGiftCards) || [];
          /* Gift card MJP nel carrello: nessuna gift card puo' pagarla (Condizioni d'uso) -> le carte si tolgono */
          if (cards.length && state() && state().getAttribute('data-gc-blocked') === 'true') {
            return G.myCart().then(function (c) { return G.removeCards(c.gid, cards.map(function (g) { return g.id; }), cart); })
              .then(function (c2) { cards = (c2 && c2.appliedGiftCards) || []; reservation = null; renderGC(); try { window.kachingCartApi.refreshCart(); } catch (e) {} });
          }
          if (!cards.length) reservation = null; renderGC();
        })
          .catch(function () {});
      });
    }
    function notice(text) {
      if (!text) return;
      var b = body(), rows = b && b.querySelector('.mct-sum__rows');
      if (!rows) return;
      var p = rows.querySelector('.mct-sum__notice');
      if (!p) { p = document.createElement('p'); p.className = 'mct-sum__notice'; p.setAttribute('role', 'alert'); rows.insertBefore(p, rows.firstChild); }
      p.textContent = text;
    }

    function removeCard(btn) {
      btn.disabled = true;
      whenGC(function (G) {
        G.myCart().then(function (c) { return G.status(c.gid).then(function (cart) { return G.removeCards(c.gid, [btn.getAttribute('data-mct-gc-rm')], cart); }); })
          .then(function (cart) { cards = (cart && cart.appliedGiftCards) || []; if (!cards.length) reservation = null; renderGC(); })
          .catch(function () { btn.disabled = false; });
      });
    }

    document.addEventListener('mjp:gc-applied', function (e) {
      var c = e.detail && e.detail.cart;
      var res = e.detail && e.detail.reservation;
      reservation = res && res.reservation_id ? res : reservation;
      var n = body() && body().querySelector('.mct-sum__notice'); if (n) n.remove();
      if (c && c.appliedGiftCards) { cards = c.appliedGiftCards; renderGC(); }
      /* Carta applicata dal telefono (QR): la riserva la conosce solo l'ERP -> si rilegge (rinnovo) */
      if (!res || !c) { first = true; loadGC(); }
      if (dlg && dlg.hasAttribute('open')) setTimeout(closeScanner, 1800);
    });

    /* ---------------- consensi (Impostazioni tema > Carrello: termini e privacy) ---------------- */
    /* Nomi degli attributi del carrello: compaiono cosi' nell'ordine, in "Dettagli aggiuntivi" */
    var LEGAL = { terms: 'Termini e condizioni', returns: 'Politica di resi', privacy: 'Informativa privacy' };
    function legalBox() { return body() && body().querySelector('[data-mct-legal]'); }
    function termsOk() {
      var lb = legalBox(); if (!lb) return true;
      var c = lb.querySelector('[data-mct-terms]'); return !!(c && c.checked);
    }
    function legalError(fromDrawer) {
      var lb = legalBox(); if (!lb) return;
      if (fromDrawer) { try { window.kachingCartApi.closeCart(); } catch (e) {} }
      lb.querySelector('[data-mct-legal-err]').hidden = false;
      lb.classList.remove('is-error'); void lb.offsetWidth; lb.classList.add('is-error');
      lb.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { var c = lb.querySelector('[data-mct-terms]'); if (c) c.focus({ preventScroll: true }); }, 450);
    }
    function stamp() {
      try { return new Date().toLocaleString('it-IT', { timeZone: 'Europe/Rome', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }); }
      catch (e) { return new Date().toISOString(); }
    }
    /* Accettazione salvata nel carrello -> ordine: data, ora e pagina accettata */
    function saveLegal() {
      var lb = legalBox(); if (!lb) return Promise.resolve();
      var when = stamp(), links = lb.querySelectorAll('.mct-check__txt a'), plink = lb.querySelector('.mct-legal__privacy a');
      var path = function (a) { try { return new URL(a.href, location.href).pathname; } catch (e) { return ''; } };
      var attrs = {};
      attrs[LEGAL.terms] = 'Accettati il ' + when + (links[0] ? ' (' + path(links[0]) + ')' : '');
      attrs[LEGAL.returns] = 'Accettata il ' + when + (links[1] ? ' (' + path(links[1]) + ')' : '');
      attrs._mjp_gc_view = ''; /* resto di una consultazione col telefono: non deve finire nell'ordine */
      if (lb.querySelector('.mct-legal__privacy')) attrs[LEGAL.privacy] = 'Presa visione il ' + when + (plink ? ' (' + path(plink) + ')' : '');
      return fetch(ROOT_URL + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
    }
    root.addEventListener('change', function (e) {
      if (!e.target.closest('[data-mct-terms]')) return;
      var lb = legalBox(); if (!lb) return;
      lb.classList.remove('is-error');
      lb.querySelector('[data-mct-legal-err]').hidden = true;
    });

    /* Prima del pagamento (pulsante della pagina o "Checkout" di Kaching): consensi, poi rinnovo della gift card.
       Risolve true se si puo' andare al pagamento. */
    function checkoutFlow(opts) {
      var fromDrawer = opts && opts.fromDrawer;
      if (!termsOk()) { legalError(fromDrawer); return Promise.resolve(false); }
      return saveLegal().catch(function () {}).then(function () {
        if (!(gcOn && cards.length && reservation && window.MJPGiftCart)) return true;
        return window.MJPGiftCart.beforeCheckout().then(function (ok) {
          if (!ok) {
            if (fromDrawer) { try { window.kachingCartApi.closeCart(); } catch (e) {} }
            reservation = null; first = true; loadGC(); notice((window.MJPGiftCart.config.t || {}).expired);
          }
          return ok;
        });
      });
    }
    window.MJPCartCheckout = checkoutFlow;

    var going = false;
    root.addEventListener('submit', function (e) {
      var form = e.target;
      if (going) return;
      e.preventDefault();
      going = true;
      root.classList.add('is-busy');
      checkoutFlow().then(function (ok) {
        if (!ok) { going = false; root.classList.remove('is-busy'); return; }
        var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; form.appendChild(h);
        form.submit();
      });
    });

    /* ---------------- testo di Termini / Resi / Privacy in una finestra ---------------- */
    var doc = root.querySelector('[data-mct-doc-dlg]');
    function openDoc(a) {
      if (!doc) { window.open(a.href, '_blank', 'noopener'); return; }
      var title = a.getAttribute('title') || a.textContent, bodyEl = doc.querySelector('[data-mct-doc-body]');
      doc.querySelector('[data-mct-doc-title]').textContent = title;
      bodyEl.innerHTML = '<span class="mct-doc__spin" aria-hidden="true"></span>';
      if (doc.showModal) doc.showModal(); else doc.setAttribute('open', '');
      var url = new URL(a.href, location.href);
      if (url.origin !== location.origin) { closeDoc(); window.open(a.href, '_blank', 'noopener'); return; }
      if (/\/pages\//.test(url.pathname)) url.searchParams.set('view', 'mjp-raw');
      fetch(url.toString(), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          var c = d.querySelector('[data-mjp-raw]') || d.querySelector('.shopify-policy__body') || d.querySelector('.page .prose') || d.querySelector('main');
          if (!c) throw new Error('vuoto');
          var h = c.querySelector('h1'); if (h) h.remove();
          c.querySelectorAll('script, style, iframe').forEach(function (n) { n.remove(); });
          bodyEl.innerHTML = c.innerHTML;
          bodyEl.scrollTop = 0;
        })
        .catch(function () { closeDoc(); window.open(a.href, '_blank', 'noopener'); });
    }
    function closeDoc() { if (!doc) return; if (doc.close && doc.open) doc.close(); else doc.removeAttribute('open'); }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('.mct-legal__rte a');
      if (a) { e.preventDefault(); openDoc(a); return; }
      if (e.target.closest('[data-mct-doc-close]') || e.target === doc) closeDoc();
    });

    /* ---------------- lettore nel dialog ---------------- */
    var dlg = root.querySelector('[data-mct-scan-dlg]');
    function openScanner(mode) {
      if (!dlg) return;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var reader = dlg.querySelector('[data-mgc-reader]');
      if (mode === 'old') { if (reader && reader.mgcOpenOld) reader.mgcOpenOld(); return; } /* codice del vecchio sistema */
      var start = dlg.querySelector('[data-rd-start]');
      if (start && !start.hidden) start.click();
    }
    function closeScanner() {
      if (!dlg) return;
      var stop = dlg.querySelector('[data-rd-stop]');
      if (stop) stop.click(); /* spegne la fotocamera e torna allo stato iniziale */
      if (dlg.close && dlg.open) dlg.close(); else dlg.removeAttribute('open');
    }
    if (dlg) {
      dlg.addEventListener('click', function (e) { if (e.target === dlg) closeScanner(); });
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeScanner(); });
    }

    if (gcOn) loadGC();
  }

  function boot() { document.querySelectorAll('[data-mct]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-mct]');
    if (r) init(r);
  });
  /* Torna sulla pagina dalla cache del browser (es. "indietro" dal checkout): dati freschi */
  window.addEventListener('pageshow', function (e) { if (e.persisted) location.reload(); });
})();
